import React, {useEffect, useState} from "react";
import {GiftOutlined, SmileOutlined, TrophyOutlined} from "@ant-design/icons";
import '../../../styles/component/celebrations/celebrations.tabs.scss';
import CelebrationCards from "./celebrations.cards";
import {CelebrationTabsProps} from "../celebrations.view";
import {useLocation} from "react-router-dom";

const CelebrationTabs: React.FC<CelebrationTabsProps> = ({
                                                             newBirthdayData,
                                                             newAnniversaryData,
                                                         }) => {

    const location = useLocation();
    const [activeCategory, setActiveCategory] = useState<string>(location.state?.category || "allCelebrations");
    const [activeTimeFilter, setActiveTimeFilter] = useState<string>(location.state?.timeFilter || "today");

    const celebrationCategoryTabs = [
        {
            title: "All Celebrations",
            key: 'allCelebrations',
            icon: <SmileOutlined/>,
        },
        {
            title: "Birthdays",
            key: 'birthdays',
            icon: <GiftOutlined/>,
        },
        {
            title: "Work Anniversaries",
            key: 'workAnniversaries',
            icon: <TrophyOutlined/>,
        },
    ];

    const celebrationTimeTabs = [
        {
            title: "Today",
            key: 'today',
        },
        {
            title: "Upcoming",
            key: 'upcoming',
        },
        {
            title: "Passed",
            key: 'passed',
        },
    ];

    function handleCategoryChange(key: string) {
        setActiveCategory(key);
    }

    function handleTimeFilterChange(key: string) {
        setActiveTimeFilter(key)
    }

    useEffect(() => {
        // If user came from View All navigation, don't change filter.
        if (location.state?.category || location.state?.timeFilter) return;
        // Logic runs only when category = All Celebrations.
        if (activeCategory !== "allCelebrations") return;

        const todayCount =
            (newBirthdayData?.today?.length || 0) +
            (newAnniversaryData?.today?.length || 0);

        const upcomingCount =
            (newBirthdayData?.upcoming?.length || 0) +
            (newAnniversaryData?.upcoming?.length || 0);

        const passedCount =
            (newBirthdayData?.passed?.length || 0) +
            (newAnniversaryData?.passed?.length || 0);

        if (todayCount === 0 && upcomingCount > 0) {
            setActiveTimeFilter("upcoming");
        } else if (todayCount === 0 && upcomingCount === 0 && passedCount > 0) {
            setActiveTimeFilter("passed");
        } else {
            setActiveTimeFilter("today");
        }
    }, [newBirthdayData, newAnniversaryData]);

    return (
        <>
            <div className="celebrations-tabs">
                <div className="celebration-event-tabs">
                    {celebrationCategoryTabs.map((item) => (
                        <button
                            key={item.key}
                            className={`celebration-tab-button ${
                                activeCategory === item.key ? "active" : ""
                            }`}
                            onClick={() => handleCategoryChange(item.key)}
                        >
                            {item.icon} {item.title}
                        </button>
                    ))}
                </div>

                <div className="celebration-event-tabs">
                    {celebrationTimeTabs.map((item) => (
                        <button
                            key={item.key}
                            className={`celebration-tab-button ${
                                activeTimeFilter === item.key ? "active" : ""
                            }`}
                            onClick={() => handleTimeFilterChange(item.key)}
                        >
                            {item.title}
                        </button>
                    ))}
                </div>
            </div>

            <CelebrationCards
                activeCategory={activeCategory}
                activeTimeFilter={activeTimeFilter}
                birthdayData={newBirthdayData}
                anniversaryData={newAnniversaryData}
            />

        </>
    );
}

export default CelebrationTabs;